export const endpoints = {
  // Tracking realm (shared with Tracking Mobile, `aud: tracking`). See ADR-0005.
  auth: {
    me: '/auth/tracking/me',
    login: '/auth/tracking/login',
    logout: '/auth/tracking/logout',
    refresh: '/auth/tracking/refresh',
    signup: '/auth/tracking/signup',
    otpSend: '/auth/tracking/login/otp/send',
    otpVerify: '/auth/tracking/login/otp/verify',
    forgotSend: '/auth/tracking/forgot-password/send',
    forgotVerify: '/auth/tracking/forgot-password/verify',
    forgotReset: '/auth/tracking/forgot-password/reset',
  },

  // ── FieldPro placeholder endpoint groups (paths firm up per feature) ──────────
  devices: {
    list: '/devices/tracking/devices',
    detail: (id: string) => `/devices/tracking/devices/${id}`,
    onboard: '/devices/tracking/devices/onboard',
    command: (id: string) => `/devices/tracking/devices/${id}/command`,
    commandStatus: (id: string) => `/devices/tracking/devices/${id}/command-status`,
  },
  telemetry: {
    latest: (id: string) => `/telemetry/tracking/devices/${id}/latest`,
    history: (id: string) => `/telemetry/tracking/devices/${id}/history`,
    activityCalendar: (id: string) => `/telemetry/tracking/devices/${id}/activity-calendar`,
  },
  fields: {
    list: '/fields/tracking/fields',
    detail: (id: string) => `/fields/tracking/fields/${id}`,
    import: '/fields/tracking/fields/import',
    boundaries: (id: string) => `/fields/tracking/fields/${id}/boundaries`,
  },
  wells: {
    list: '/fields/tracking/wells',
    detail: (id: string) => `/fields/tracking/wells/${id}`,
    pumps: (id: string) => `/fields/tracking/wells/${id}/pumps`,
  },
  subscriptions: {
    list: '/subscriptions/tracking/subscriptions',
    renew: (id: string) => `/subscriptions/tracking/subscriptions/${id}/renew`,
    renewAll: '/subscriptions/tracking/subscriptions/renew-all',
    autoRenew: (id: string) => `/subscriptions/tracking/subscriptions/${id}/auto-renew`,
  },
  support: {
    tickets: '/support/tracking/tickets',
    detail: (id: string) => `/support/tracking/tickets/${id}`,
    messages: (id: string) => `/support/tracking/tickets/${id}/messages`,
    raise: '/support/tracking/tickets',
  },
  warranty: {
    claims: '/warranty/tracking/claims',
    detail: (id: string) => `/warranty/tracking/claims/${id}`,
    eligibility: (deviceId: string) => `/warranty/tracking/devices/${deviceId}/eligibility`,
  },
  notifications: {
    list: '/notifications/tracking/notifications',
    readAll: '/notifications/tracking/notifications/read-all',
    read: (id: string) => `/notifications/tracking/notifications/${id}/read`,
    settings: '/notifications/tracking/settings',
  },
  profile: {
    me: '/profile/tracking/me',
    changePhone: '/profile/tracking/me/phone',
    changePassword: '/profile/tracking/me/password',
  },
  storage: {
    presignedUrl: '/storage/tracking/pre-signed-url',
  },
} as const;
